define('SuiteDynamics.PDPImageGalleryGrid.Entrypoint',
	[
		'Utils',
		'SuiteDynamics.PDPImageGalleryGrid.ImageGallery.View',
		'SuiteDynamics.ItemExtensions'
	],
	function (
		Utils,
		ImageGalleryView,
		ItemModelExtensions
	)
{
	'use strict';

	return  {
		mountToApp: function mountToApp (container) {
			ItemModelExtensions.mountToApp(container);

			var environment = container.getComponent('Environment');
			var showInQuickView = environment.getConfig('imageGalleryGrid.showInQuickView') || false;
			var extComponentName = showInQuickView ? 'Layout' : 'PDP';
			var extComponent = container.getComponent(extComponentName);
			var isDesktop = Utils.isDesktopDevice();

			if (extComponent && isDesktop) {
				extComponent.removeChildView('Product.ImageGallery');
				extComponent.addChildView('Product.ImageGallery', function () {
					return new ImageGalleryView({
						container: container
					});
				});
			}
		}
	};
});
